import IconExcel from "@/assets/icones/excel.svg?react";
import IconImg from "@/assets/icones/images.svg?react";
import IconPdf from "@/assets/icones/pdf.svg?react";
import IconWord from "@/assets/icones/word.svg?react";
import ReactBreadcrumb from "@/components/breadcrumb/Breadcrumb";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { LoadingSpinner } from "@/components/ui/loadingSpinner";
import DocumentCard from "@/documents/components/DocumentCard";
import DocumentList from "@/documents/components/DocumentList";
import FilterDocument from "@/documents/components/FilterDocument";
import { normalizeDocumentTypes } from "@/documents/utils/documentTree";
import { useFetchDataV2 } from "@/hooks/useFetchDataV2";
import SwitchList from "@/project-owner/components/SwitchList";
import { Document as DocumentType, TreeRoot } from "@/types";
import { Eye, FolderOpen } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
/* eslint-disable react/react-in-jsx-scope */
const Document = () => {
  const {
    data: treeFinancer,
    loading: loadingTreeFinancer,
    error: errorTreeFinancer,
  } = useFetchDataV2<TreeRoot[]>(
    `${import.meta.env.VITE_API_ENDPOINT}/tree/financer`,
    `tree-financer`,
    1000 * 60 * 60
  );
  const [porteursList, setPorteursList] = useState<any[]>([]);
  const [typesDocs, setTypesDocs] = useState([]);
  const navigate = useNavigate();
  const { firstname } = useParams();
  const [dataFiltered, setDataFiltered] = useState<DocumentType[]>([]);
  const { idPp } = useParams();
  useEffect(() => {
    if (treeFinancer) {
      if (
        errorTreeFinancer ||
        !treeFinancer.find((pp) => pp.id === parseInt(idPp as string))
      ) {
        navigate("/error");
      }
    }
  }, [treeFinancer, idPp]);
  useEffect(() => {
    if (treeFinancer && treeFinancer.length > 0) {
      const options = treeFinancer.map((item: TreeRoot) => {
        return {
          id: item.id,
          name: item.name,
        };
      });
      setPorteursList(options);
    }
  }, [treeFinancer]);
  const { t } = useTranslation("dashboard", {
    keyPrefix: "details",
  });
  const [view, setView] = useState<"list" | "card">("card");

  const { data: dataDocuments, loading: loadingDocuments } = useFetchDataV2<
    DocumentType[]
  >(
    `${import.meta.env.VITE_API_ENDPOINT}/docs/financer`,
    `docs-financer`,
    1000 * 60 * 60
  );

  useEffect(() => {
    const localStorageKey = "typesDocsCache";

    const cached = localStorage.getItem(localStorageKey);
    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        if (Array.isArray(parsed)) {
          setTypesDocs(normalizeDocumentTypes(parsed));
          return; // Pas besoin de fetch
        }
      } catch (e) {
        console.warn(
          "Échec du parsing du cache localStorage, on refait un fetch"
        );
      }
    }

    // Sinon on fetch et on stocke
    fetch(`${import.meta.env.VITE_IP_API}/types-docs.json`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data) {
          setTypesDocs(normalizeDocumentTypes(data));
          localStorage.setItem(localStorageKey, JSON.stringify(data));
        }
      })
      .catch((error) => {
        console.error("Erreur lors du fetch :", error);
      });
  }, []);

  const optionsType = [
    {
      value: "document",
      label: "Documents",
      icon: <IconWord width={18} height={18} />,
    },
    {
      value: "spreadsheet",
      label: "Feuilles de calcul",
      icon: <IconExcel width={18} height={18} />,
    },
    {
      value: "image",
      label: "Photos et images",
      icon: <IconImg width={18} height={18} />,
    },
    {
      value: "pdf",
      label: "Fichiers PDF",
      icon: <IconPdf width={18} height={18} />,
    },
  ];
  const [programsList, setProgramsList] = useState([]);
  const [projectList, setProjectsList] = useState([]);
  useEffect(() => {
    if (treeFinancer && treeFinancer.length > 0) {
      const optionsPrograms = treeFinancer
        .find((pp) => pp.id === parseInt(idPp))
        ?.programs.map((program) => {
          return {
            id: program.id,
            name: program.name,
            projects: program.projects?.map((project) => project.id) || [],
          };
        });
      const optionsProject = [];
      treeFinancer
        ?.find((pp) => pp.id === parseInt(idPp))
        ?.programs.forEach((program) =>
          program.projects.forEach((project) => (
            optionsProject.push({
              id: project.id,
              name: project.name,
            })))
        );
      if (optionsPrograms) {
        setProgramsList(optionsPrograms);
      }
      if (optionsProject) {
        setProjectsList(optionsProject);
      }
    }
  }, [treeFinancer, idPp]);

  return (
    <div>
      <div className="mb-5">
        <ReactBreadcrumb
          items={[
            {
              href: `/${firstname}`,
              name: t("Tableau de bord"),
            },
            {
              href: `/${firstname}/mes-documents`,
              name: t("Mes documents"),
            },
            {
              href: ``,
              name:
                treeFinancer?.find(
                  (item: TreeRoot) => item.id === parseInt(idPp as string)
                )?.name || "",
            },
          ]}
          isTruncated={false}
        />
      </div>
      <h1 className="text-3xl font-bold mb-5">{t("Mes documents")}</h1>
      <section>
        <Accordion
          type="single"
          collapsible
          className="w-full mb-5"
          defaultValue="Initiale"
        >
          <AccordionItem value="Initiale" className="border-0 " key={"0"}>
            <AccordionTrigger
              className="py-[10px] hover:no-underline group pl-4 border-b border-b-white relative  hover:bg-muted rounded-[9px] transition-all w-auto -ml-4"
              backgroundClassName="bg-[#FFFF]"
            >
              <div className="flex justify-between items-start w-full pr-[18px] pl-2  ">
                <div className="flex items-center gap-2 flex-1 text-left pr-4">
                  <div className="flex-1 group-hover:underline font-semibold">
                    Porteurs de projet
                  </div>
                </div>
              </div>
            </AccordionTrigger>
            <AccordionContent>
              <div className="flex flex-wrap gap-2 mt-3">
                {porteursList &&
                  porteursList?.map((pp: TreeRoot) => (
                    <div key={pp.id}>
                      <Link
                        to={`/${firstname}/mes-documents/${pp.id}`}
                        className={`flex items-center gap-2 border rounded-md py-3 px-4 hover:bg-primary transition-all ${pp.id === Number(idPp)
                          ? "bg-primary border-primary"
                          : "bg-gray-100"
                          }`}
                      >
                        <FolderOpen />
                        <div className="flex-1">{pp.name}</div>
                      </Link>
                    </div>
                  ))}
                <div>
                  <Link
                    to={`/${firstname}/mes-documents`}
                    className={`flex items-center gap-2 border rounded-md py-3 px-4 hover:bg-primary transition-all bg-gray-100`}
                  >
                    <Eye />
                    <div className="flex-1">{t("Afficher tout")}</div>
                  </Link>
                </div>
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </section>
      {loadingDocuments && !typesDocs ? (
        <LoadingSpinner />
      ) : (
        <FilterDocument
          typesDocs={typesDocs}
          optionsType={optionsType}
          dataDocuments={dataDocuments}
          setDataFiltered={setDataFiltered}
          programsList={programsList}
          projectList={projectList}
        />
      )}

      <div className="flex items-center gap-5 mb-4">
        <div className="py-[10px] flex-1 hover:no-underline group pl-4 font-semibold border-b border-b-white relative bg-[#fafafa] rounded-[9px] transition-all w-auto ">
          Mes fichiers
        </div>
        <div className="flex justify-end  ">
          <SwitchList setView={setView} view={view} />
        </div>
      </div>

      {view === "list" ? (
        <DocumentList data={dataFiltered} typesDocs={typesDocs} />
      ) : (
        <DocumentCard data={dataFiltered} />
      )}
    </div>
  );
};

export default Document;
